import fi from './fi.json'
import en from './en.json'
import sv from './sv.json'

const languages = {
  fi,
  en,
  sv,
}

export default languages
